import { createFetchAction } from '../utils';
import * as substanceActionTypes from './substanceActionTypes';

export const fetchSubstanceActions = createFetchAction(
  substanceActionTypes.FETCH_SUBSTANCE_ACTIONS,
  'substanceActionId',
);